// The firm console has no trading runtime to ask for a rule's words, so it
// loads challenge-text's own small wasm (packages/challenge-text-wasm), once,
// the first time the template builder opens. The pipeline builds it; its gzip
// size is gated.

import { installRuleText } from "@noctant/challenge-builder";

let loading: Promise<true> | null = null;

/** The rule text, installed once its module has loaded. */
export function loadRuleText(): Promise<true> {
  loading ??= (async () => {
    const text = await import("@noctant/rule-text-wasm");
    await text.default();
    installRuleText(text);
    return true as const;
  })();
  return loading;
}
